import React, { FC } from 'react';

import { Header } from './header';
import Loader from 'core/react/general/Loader';
import { ZoneOccupancy } from './zone-occupancy';
import { IZoneOccupancy } from 'types/redux/zoneGuardsOccupancy';

import styles from './styles.module.css';

interface IOccupanciesByZoneProps {
  isLoading: boolean;
  occupancies?: IZoneOccupancy[];
}

export const OccupanciesByZone: FC<IOccupanciesByZoneProps> = ({ isLoading, occupancies }) => {
  return (
    <div className={styles.wrapper}>
      <Header />
      {isLoading ? (
        <div className={styles.noContent}>
          <Loader className="loader" size={Loader.Size.MD} />
        </div>
      ) : occupancies?.length ? (
        occupancies?.map((occupancy) => <ZoneOccupancy key={occupancy.zoneId} occupancy={occupancy} />)
      ) : (
        <div className={styles.noContent}>No data</div>
      )}
    </div>
  );
};
